<div [formGroup]="languageForm" class="language-class-wrap">
    <mat-select formControlName="language" name="Language" class="language-class dropdown-wrapper" panelClass="dropdown-wrapper">
        <mat-option *ngFor="let lt of languageList" class="option-list" [value]="lt.settingValueId">{{ lt.value }}</mat-option>
    </mat-select>
</div>
